function cartItems() {
  const cartItems = document.querySelectorAll(
    'quantity-input input.quantity__input'
  );
  let items = '';

  cartItems.forEach((ci, idx) => {
    const id = ci.getAttribute('data-quantity-variant-id');
    const qtn = ci.value;
    if (idx > 0) {
      items += `,${id}:${qtn}`;
    } else {
      items += `${id}:${qtn}`;
    }
  });
  console.log(items);
  return items;
}
